/* eslint-disable eqeqeq */
import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import style from './style/zaptic-radio-group-style'

export enum Events {
    onSelected = 'onSelected',
}

export interface CustomEventPayload {
    [Events.onSelected]: RadioOption['value']
}

export interface RadioOption<T = string | number> {
    label?: string
    labelTranslationKey?: string
    detail?: string
    detailTranslationKey?: string
    value: T
}

@customElement('zaptic-radio-group')
export class RadioGroup extends LitElement {
    static styles = style

    @property({ type: Array })
    options: RadioOption[] = []
    @property()
    groupName: string
    @property()
    groupLabel?: string
    @property()
    groupLabelTranslationKey?: string
    @property()
    selectedValue: RadioOption['value']

    private onInputSelected(event: CustomEvent<string | number>) {
        this.dispatchEvent(new CustomEvent<CustomEventPayload['onSelected']>(Events.onSelected, event))
    }

    render() {
        return html`
            <fieldset>
                <legend>
                    ${this.groupLabelTranslationKey ? window.i18n(this.groupLabelTranslationKey) : this.groupLabel}
                </legend>
                ${this.options.map(
                    ({ detail, label, value, labelTranslationKey, detailTranslationKey }) =>
                        html`<zaptic-radio
                            class="radio"
                            @onSelected=${(e: CustomEvent<string | number>) => this.onInputSelected(e)}
                            label=${labelTranslationKey ? window.i18n(labelTranslationKey) : label}
                            detail=${detailTranslationKey ? window.i18n(detailTranslationKey) : detail}
                            value=${value}
                            groupName=${this.groupName}
                            .selected=${this.selectedValue == value}
                        ></zaptic-radio>`
                )}
            </fieldset>
        `
    }
}
